import { Task } from "@dhx/react-gantt";
import { Phase } from "../types";

export type RagStatus = "green" | "amber" | "red";

export interface ProjectForGantt {
  id: string | number;
  title: string;
  project_reference: string;
  planned_start_date?: string | null;
  planned_end_date?: string | null;
  progress?: { percentage: number };
  phases?: Phase[];
  rag?: {
    time: RagStatus;
    cost: RagStatus;
    quality: RagStatus;
    overall: RagStatus;
  };
}

const RAG_COLORS: Record<RagStatus, string> = {
  green: "#4caf50",
  amber: "#ff9800",
  red: "#f44336",
};

export const transformProjectToGanttTask = (project: ProjectForGantt): Task => {
  const startDate = project.planned_start_date
    ? new Date(project.planned_start_date)
    : new Date();

  const endDate = project.planned_end_date
    ? new Date(project.planned_end_date)
    : new Date(startDate.getTime() + 30 * 24 * 60 * 60 * 1000); // Default 30 days

  const duration = Math.max(
    1,
    Math.ceil((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24))
  );

  const progress = (project.progress?.percentage || 0) / 100;
  const ragColor = project.rag?.overall ? RAG_COLORS[project.rag.overall] : undefined;

  return {
    id: `project_${project.id}`,
    text: project.title,
    type: "task",
    start_date: startDate,
    duration,
    progress,
    parent: 0,
    open: true,
    ...(ragColor && { color: ragColor }),
  };
};

export const transformProjectsToGanttTasks = (
  projects: ProjectForGantt[]
): Task[] => {
  return projects.map(transformProjectToGanttTask);
};
